import { render, staticRenderFns } from "./RadioComponent.vue?vue&type=template&id=1b53725c&scoped=true&"
import script from "./RadioComponent.vue?vue&type=script&lang=js&"
export * from "./RadioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b53725c",
  null
  
)

export default component.exports